import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function PlanoNaoContratado() {
  const { t } = useTranslation('translation');
  return <Typography variant='h4' textAlign='center' color='textDisabled'>{t('ActionPlan.noAccessToActionPlans')}</Typography>;

}
